import { dateFormat, decryptedValue, downloadDocument } from "common/utility";
import CommonDialog from "components/Common/CommonDialog";
import DeleteModal from "components/Common/DeleteModal";
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import { useFormik } from "formik";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {
  callITRDeleteRecord,
  callITRLists,
  callITRUserCredinatialsSubmit,
  callITRUserFileUpload,
  callITRUserXMLUpload,
} from "http/fundLync/entityDocuments.helper";
import { startCase } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import Select from "react-select";
import {
  Col,
  Form,
  FormFeedback,
  Input,
  Label
} from "reactstrap";
import * as Yup from "yup";


const TableActionsComponent = (deleteClickFn) =>{

  
  return (
    <div style={{ display: "flex", gap: "10px" }}>
     <i
              className="mdi  mdi-trash-can-outline action-icon"
              title="Delete"
              onKeyUp={()=>{}}
              onClick={() => {
                deleteClickFn()
              }}
            ></i>
  </div>
  )
}


const TableFileComponent = (value,isPendingFile,fileDownloadFn) =>{
  if(value && !isPendingFile) {
    return <i className="mdi mdi-file-download-outline action-icon" onClick={fileDownloadFn} onKeyUp={()=>{}}></i> 
  }else if(isPendingFile){
    return <span>Pending</span>
  }else
  {
    return <></>
  } 
}

const ITRDocuments = (props) => {
  document.title = "ITR Documents | FundLync";
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [showCommonDialog, setShowCommonDialog] = useState({isShow:false});
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogObj, setDialogObj] = useState();

  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [itrSelectedGroup, setItrSelectedGroup] = useState(null);
  const [itrSelectedOptions, setItrSelectedOptions] = useState([]);

  const [itrFileList, setItrFileList] = useState([]);

  const [pagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [itrSortingOptions, setItrSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage] = useState(null);
  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile) {
      validationFileUpload.setFieldValue("fileUpload", selectedFile);
    } else {
      validationFileUpload.setFieldValue("fileUpload", "");
    }
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  useEffect(()=>{
  const userDetails = decryptedValue(localStorage.getItem("user"));
    if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
      setEncodedId(urlParams.get("id"))
      setEntityId(atob(encodedId))
    }else{
      setEncodedId(entityId)
      setEntityId(userDetails.entityId)
    }
},[ entityId, encodedId])

  const itrColumns = useMemo(
    () => [
      {
        Header: "PAN",
        accessor: "pan",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Status",
        accessor: "statusMsg",
        filterable: true,
        Cell: (cellProps) => {
          return startCase(cellProps.value) || "";
        },
      },
      {
        Header: "Message",
        accessor: "message",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Updated On",
        accessor: "createdAt",
        filterable: true,
        Cell: (cellProps) => {
          return dateFormat(cellProps.value || "", "DD-MM-YYYY");
        },
      },
      {
        Header: "Uploaded ITR File",
        accessor: "file",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value,false,()=>{
            downloadDocument(cellProps.value)
          })
        },
      },
      {
        Header: "ITR Report File",
        accessor: "responseFile",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value,!cellProps.value,()=>{
            downloadDocument(cellProps.value)
          })
        }
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(()=>{
            setDialogObj(rowData);
            setDeleteDialog(true);
      });  
        },
      },
    ],
    []
  );

  const validationUserCredentials = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      pan: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      password: Yup.string().required("Password is required"),
      pan: Yup.string()
        .matches(API_SERVICES.PAN_PATTERN, "Enter valid PAN pattern")
        .required("PAN is required"),
    }),
    onSubmit: (values) => {
      submitITRUserNamePassword(values);
    },
  });

  const validationFileUpload = useFormik({
    enableReinitialize: true,

    initialValues: {
      pan: "",
      fileUpload: "",
    },
    validationSchema: Yup.object({
      pan: Yup.string()
      .matches(/[A-Z]{5}\d{4}[A-Z]$/, "Enter valid PAN pattern")
        .required("PAN is required"),
      fileUpload: Yup.mixed().required("File is required"),
    }),
    onSubmit: (values) => {
      if (itrSelectedGroup.value != "xml_upload") submitITRFileUpload(values);
      else submitITRXMLUpload(values);
    },
  });

  useEffect(() => {
    getDropDownList({ dropdownName: "itr" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "itr")
            ?.dropdownValues || [];
        setItrSelectedOptions(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
if(entityId){
  loadITRList();
}
  }, [entityId]);

  const loadITRList = async () => {
    const postParams = {
      entity_id: entityId,
      type: "itr",
    };
    callITRLists(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { data } = response;
          setItrFileList(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
  };

  const handleSortColumn = (option) => {
    setItrSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "", "id", "desc");
  };

  const submitITRUserNamePassword = async (values) => {
    // const entityId = await getUser('entityId')
    setLoading(true);
    const postParams = {
      username: values.username,
      password: values.password,
      tag: values.pan,
      entity_id: entityId,
    };

    callITRUserCredinatialsSubmit(postParams)
      .then((response) => {
        setLoading(false);
        if (response.code == 200 && response.status) {
          const {  message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          validationUserCredentials.resetForm();
          setItrSelectedGroup(null);
          loadITRList();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const submitITRFileUpload = async (value) => {
    // const { entityId } = await getUser()
    setLoading(true);
    const postparams = {
      payload: { pan: value.pan, tag: value.pan },
      type: itrSelectedGroup.value == "acknowledge_upload" ? "ack" : "pdf",
      entityId: entityId,
    };


    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadProgress(percentage);
      },
    };

    callITRUserFileUpload(postparams, value.fileUpload, config)
      .then((response) => {
        setLoading(false);
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          validationFileUpload.resetForm();
          setItrSelectedGroup(null);
          setUploadProgress(0);
          loadITRList();
        } else {
          const { message } = response;
          setToastInfo({ message: "error while uploading", showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const submitITRXMLUpload = async (value) => {
    // const { entityId } = await getUser()
    setLoading(true);
    const postparams = {
      payload: { pan: value.pan, tag: value.pan },
      entityId: entityId,
    };

    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadProgress(percentage);
      },
    };

    callITRUserXMLUpload(postparams, value.fileUpload, config)
      .then((response) => {
        setLoading(false);
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          validationFileUpload.resetForm();
          setItrSelectedGroup(null);
          setUploadProgress(0);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const deleteITRRecord = () => {
    setDeleteDialog(false);

    const postParams = {
      id: dialogObj?.id,
    };

    callITRDeleteRecord(postParams)
      .then((response) => {        
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          const filterRemoveData = itrFileList.filter(
            (d) => d.id != dialogObj?.id
          );
          setItrFileList(filterRemoveData);
          setDialogObj(null);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dialogAction = (action,data) =>{
    
    if(data.type=='itr_user' && action==1)
    {
        setShowCommonDialog({isShow:false})
        validationUserCredentials.handleSubmit();
    }else if(data.type=='itr_file' && action==1)
    {
      setShowCommonDialog({isShow:false})
      validationFileUpload.handleSubmit();
    }else {
     
        setShowCommonDialog({isShow:false})
    }
}

  return (
    <React.Fragment>
        <div className="row">
          <Col sm="12" md="4" className="mb-3">
            <Label>Select option to fetch ITR</Label>

            <Select
              value={itrSelectedGroup}
              onChange={(e) => {
                setItrSelectedGroup(e);
                validationFileUpload.resetForm();
                validationUserCredentials.resetForm();
              }}
              options={itrSelectedOptions.map((o) => {
                return { label: o.displayName, value: o.dropdownValue };
              })}
            />
          </Col>
          <Col xl="12">
            {itrSelectedGroup &&
              itrSelectedGroup.value == "username_password" && (
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setShowCommonDialog({isShow:true,data:{type:'itr_user'},message:'Are you sure want to submit ITR?'})
                    return false;
                  }}
                >
                  <div className="row">
                    <Col sm="12" md="4">
                      <div className="mb-3">
                        <Label
                          htmlFor="validationUsername"
                          className="required-sign"
                        >
                          ITR Username <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="username"
                          placeholder="Enter Username"
                          type="text"
                          className="form-control"
                          id="validationUsername"
                          onChange={validationUserCredentials.handleChange}
                          onBlur={validationUserCredentials.handleBlur}
                          value={
                            validationUserCredentials.values.username || ""
                          }
                          invalid={
                            validationUserCredentials.touched.username &&
                            validationUserCredentials.errors.username
                          }
                        />

                        {validationUserCredentials.touched.username &&
                        validationUserCredentials.errors.username ? (
                          <FormFeedback type="invalid">
                            {validationUserCredentials.errors.username}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col sm="12" md="4">
                      <div className="mb-3">
                        <Label
                          htmlFor="validationPassword"
                          className="required-sign"
                        >
                          ITR Password <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="password"
                          placeholder="Enter Password"
                          type="password"
                          className="form-control"
                          onChange={validationUserCredentials.handleChange}
                          onBlur={validationUserCredentials.handleBlur}
                          value={
                            validationUserCredentials.values.password || ""
                          }
                          invalid={
                            validationUserCredentials.touched.password &&
                            validationUserCredentials.errors.password
                          }
                        />

                        {validationUserCredentials.touched.password &&
                        validationUserCredentials.errors.password ? (
                          <FormFeedback type="invalid">
                            {validationUserCredentials.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col sm="12" md="4">
                      <div className="mb-3">
                        <Label
                          htmlFor="validationPan"
                          className="required-sign"
                        >
                          PAN <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="pan"
                          placeholder="Enter PAN"
                          type="text"
                          className="form-control"
                          id="validationPan"
                          onChange={validationUserCredentials.handleChange}
                          onBlur={validationUserCredentials.handleBlur}
                          value={validationUserCredentials.values.pan || ""}
                          invalid={
                            validationUserCredentials.touched.pan &&
                            validationUserCredentials.errors.pan
                          }
                        />

                        {validationUserCredentials.touched.pan &&
                        validationUserCredentials.errors.pan ? (
                          <FormFeedback type="invalid">
                            {validationUserCredentials.errors.pan}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col xl="12" className="d-flex justify-content-center mb-4">
                      <button
                        type="submit"
                        className="btn btn-success save-customer"
                        disabled={loading}
                      >
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        {loading && <span>Saving</span>}
                        {!loading && <span>Save</span>}
                      </button>
                    </Col>
                  </div>
                </Form>
              )}
            {itrSelectedGroup &&
              itrSelectedGroup.value != "username_password" && (
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setShowCommonDialog({isShow:true,data:{type:'itr_file'},message:'Are you sure want to submit ITR?'})

                    return false;
                  }}
                >
                  <div className="row d-flex align-items-center">
                    <Col sm="12" md="4">
                      <div className="mb-3">
                        <Label
                          htmlFor="validationPAN"
                          className="required-sign"
                        >
                          PAN <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="pan"
                          placeholder="Enter PAN"
                          type="text"
                          className="form-control"
                          id="validationPAN"
                          onChange={validationFileUpload.handleChange}
                          onBlur={validationFileUpload.handleBlur}
                          value={validationFileUpload.values.pan || ""}
                          invalid={
                            validationFileUpload.touched.pan &&
                            validationFileUpload.errors.pan
                          }
                        />

                        {validationFileUpload.touched.pan &&
                        validationFileUpload.errors.pan ? (
                          <FormFeedback type="invalid">
                            {validationFileUpload.errors.pan}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col sm="12"></Col>
                    <Col sm="12" md="4">
                      <div>
                        <div className="d-flex flex-column">
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-form-label"
                          >
                            Upload File (.xlsx, .xls, .jpg, .png, .jpeg, .pdf )
                            *
                          </Label>
                          <div
                            className="drop"
                            onClick={() => {
                              validationFileUpload.touched.fileUpload = true;
                            }}
                          >
                            <div {...getRootProps()} className="text-wrapper">
                              <div className="centered">
                                <input
                                  type="file"
                                  name="formatDocument"
                                  id="itrFileExcel"
                                  accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                                  {...getInputProps()}
                                />
                                <label
                                  style={{
                                    marginBottom: 0,
                                    fontSize: "14px",
                                  }}
                                  htmlFor="itrFileExcel"
                                >
                                  <img
                                    src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                                    className="img-fluid"
                                    style={{ width: "30px" }}
                                    alt="Upload"
                                  />
                                  {isDragActive && (
                                    <p className="textLink">Drop here</p>
                                  )}
                                  <span className="textLink">
                                    Browse files to attach
                                  </span>
                                  or Drop
                                </label>
                              </div>
                            </div>
                          </div>
                          {validationFileUpload.values.fileUpload && (
                            <>
                              <span className="mt-2">
                                {validationFileUpload.values.fileUpload.name}{" "}
                              </span>
                              {uploadProgress > 0 && !errorMessage && (
                                <div className="progress mt-2">
                                  <div
                                    className="progress-bar bg-success"
                                    role="progressbar"
                                    style={{ width: `${uploadProgress}%` }}
                                    aria-valuenow="0"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  >
                                    {`${uploadProgress}%`}
                                  </div>
                                </div>
                              )}
                              {errorMessage && (
                                <div className="alert alert-danger mt-2">
                                  {errorMessage}
                                </div>
                              )}
                            </>
                          )}
                          {validationFileUpload.submitCount > 0 &&
                          validationFileUpload.errors.fileUpload ? (
                            <FormFeedback
                              type="invalid"
                              style={{ display: "block" }}
                            >
                              {validationFileUpload.errors.fileUpload}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <hr />
                      </div>
                    </Col>
                    <Col sm="12"></Col>
                    <Col
                      sm="12"
                      md="4"
                      className="d-flex justify-content-center mb-4"
                    >
                      <button
                        type="submit"
                        className="btn btn-success save-customer"
                        disabled={loading}
                      >
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        {loading && <span>Saving</span>}
                        {!loading && <span>Save</span>}
                      </button>
                    </Col>
                  </div>
                </Form>
              )}
          </Col>
        </div>

        <hr className="hr-divider" />
        <div className="row">
          <TableContainerV1
            columns={itrColumns}
            data={itrFileList}
            pagination={pagination}
            handlePageChange={handlePageChange}
            handleSearchFilter={handleSearchFilter}
            sortOptions={itrSortingOptions}
            handleSortColumn={handleSortColumn}
            handleClearSearch={handleClearSearch}
            hidePageSize={true}
            hideSearchView={true}
            className="custom-header-css"
          />
        </div>
        <DeleteModal
          msg="Are you sure to delete record?"
          show={deleteDialog}
          onDeleteClick={deleteITRRecord}
          onCloseClick={() => setDeleteDialog(false)}
        />
          {showCommonDialog && 
            <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data}  postitiveBtn={'Submit'} negativeBtn={'Close'}  onCloseFn={dialogAction}></CommonDialog>
        }
        <ToastDialog
          message={toastInfo.message || ""}
          showToast={toastInfo.showToast}
          role={toastInfo.role}
          onCloseFn={() => setToastInfo({ showToast: false })}
        ></ToastDialog>
    </React.Fragment>
  );
};

export default ITRDocuments;
